import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.string.includes.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/operate/icon1.png';
import _imports_1 from '@/assets/img/operate/icon2.png';
import _imports_2 from '@/assets/img/operate/icon3.png';
import _imports_3 from '@/assets/img/operate/icon4.png';
import _imports_4 from '@/assets/img/operate/icon5.png';
import _imports_5 from '@/assets/img/operate/down.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0e15c8af"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "prodComprehensiveDaily"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "product-line"
};
var _hoisted_4 = {
  class: "title my-2"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "info"
  }, "开停机时间", -1);
});
var _hoisted_6 = {
  class: "info"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "dot mr-1"
  }, null, -1);
});
var _hoisted_8 = {
  class: "text"
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = {
  class: "child-title"
};
var _hoisted_11 = {
  class: "title"
};
var _hoisted_12 = {
  class: "date"
};
var _hoisted_13 = {
  class: "flex align-center sale-con"
};
var _hoisted_14 = {
  class: "text-left"
};
var _hoisted_15 = {
  class: "mb-1"
};
var _hoisted_16 = {
  class: "num"
};
var _hoisted_17 = {
  key: 0,
  class: "num-float"
};
var _hoisted_18 = {
  class: "text"
};
var _hoisted_19 = {
  class: "mb-2"
};
var _hoisted_20 = {
  class: "yield"
};
var _hoisted_21 = {
  class: "mb-3 flex justify-between align-end"
};
var _hoisted_22 = {
  class: "title"
};
var _hoisted_23 = {
  class: "date"
};
var _hoisted_24 = {
  class: "num-part text-left"
};
var _hoisted_25 = {
  class: "num"
};
var _hoisted_26 = {
  key: 0,
  class: "num-float"
};
var _hoisted_27 = {
  class: "text"
};
var _hoisted_28 = {
  key: 1,
  class: "px-2 mb-4"
};
var _hoisted_29 = {
  class: "desc w-100 d-inline-block pb-2 font-sm"
};
var _hoisted_30 = {
  class: "table-box"
};
var _hoisted_31 = {
  class: "mb-2 cus-table1"
};
var _hoisted_32 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("tr", {
    class: "th"
  }, [/*#__PURE__*/_createElementVNode("th", null, "原料"), /*#__PURE__*/_createElementVNode("th", null, "重量/吨"), /*#__PURE__*/_createElementVNode("th", null, "单价/元"), /*#__PURE__*/_createElementVNode("th", null, "金额/元")], -1);
});
var _hoisted_33 = {
  key: 0,
  class: "num-float"
};
var _hoisted_34 = {
  key: 0,
  class: "num-float"
};
var _hoisted_35 = {
  key: 1
};
var _hoisted_36 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("td", {
    colspan: "4",
    style: {
      "text-align": "center"
    }
  }, "暂无数据", -1);
});
var _hoisted_37 = [_hoisted_36];
var _hoisted_38 = {
  key: 2,
  class: "mb-2 px-2"
};
var _hoisted_39 = {
  class: "desc w-100 d-inline-block pb-2 font-sm"
};
var _hoisted_40 = {
  class: "table-box"
};
var _hoisted_41 = {
  class: "mb-2 table cus-table1"
};
var _hoisted_42 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("tr", {
    class: "th"
  }, [/*#__PURE__*/_createElementVNode("th", null, "原料"), /*#__PURE__*/_createElementVNode("th", null, "重量/吨"), /*#__PURE__*/_createElementVNode("th", null, "单价/元"), /*#__PURE__*/_createElementVNode("th", null, "金额/元")], -1);
});
var _hoisted_43 = {
  key: 0,
  class: "num-float"
};
var _hoisted_44 = {
  key: 0,
  class: "num-float"
};
var _hoisted_45 = {
  key: 1
};
var _hoisted_46 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("td", {
    colspan: "4"
  }, "暂无数据", -1);
});
var _hoisted_47 = [_hoisted_46];
var _hoisted_48 = ["onClick"];
var _hoisted_49 = {
  class: "child-title"
};
var _hoisted_50 = {
  class: "title"
};
var _hoisted_51 = {
  class: "date"
};
var _hoisted_52 = {
  class: "flex align-center sale-con"
};
var _hoisted_53 = {
  class: "flex-1 flex justify-center align-center"
};
var _hoisted_54 = {
  class: "text-left"
};
var _hoisted_55 = {
  class: "mb-1"
};
var _hoisted_56 = {
  class: "num"
};
var _hoisted_57 = {
  key: 0,
  class: "num-float"
};
var _hoisted_58 = {
  class: "text"
};
var _hoisted_59 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});
var _hoisted_60 = {
  class: "flex-1 flex justify-center align-center"
};
var _hoisted_61 = {
  class: "text-left"
};
var _hoisted_62 = {
  class: "mb-1"
};
var _hoisted_63 = {
  class: "num"
};
var _hoisted_64 = {
  key: 0,
  class: "num-float"
};
var _hoisted_65 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "text"
  }, "总销售额/万元", -1);
});
var _hoisted_66 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});
var _hoisted_67 = {
  class: "flex-1 flex justify-center align-center"
};
var _hoisted_68 = {
  class: "text-left"
};
var _hoisted_69 = {
  class: "mb-1"
};
var _hoisted_70 = {
  class: "num"
};
var _hoisted_71 = {
  key: 0,
  class: "num-float"
};
var _hoisted_72 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "text"
  }, "总单数/单", -1);
});
var _hoisted_73 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});
var _hoisted_74 = {
  class: "flex-1 flex justify-center align-center"
};
var _hoisted_75 = {
  class: "text-left"
};
var _hoisted_76 = {
  class: "mb-1"
};
var _hoisted_77 = {
  class: "num"
};
var _hoisted_78 = {
  key: 0,
  class: "num-float"
};
var _hoisted_79 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "text"
  }, "总均价/元", -1);
});
var _hoisted_80 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "font-small text-skyblue"
  }, "编辑", -1);
});
var _hoisted_81 = {
  key: 4,
  class: "receiveMoney box1 flex align-center"
};
var _hoisted_82 = {
  class: "item-title font-sm mb-2"
};
var _hoisted_83 = {
  class: "num-part text-left"
};
var _hoisted_84 = {
  class: "num"
};
var _hoisted_85 = {
  key: 0,
  class: "num-float"
};
var _hoisted_86 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "元", -1);
});
var _hoisted_87 = {
  class: "date"
};
var _hoisted_88 = {
  key: 6,
  class: "attendance px-2 flex"
};
var _hoisted_89 = {
  class: "attendance-left font-small text-grey"
};
var _hoisted_90 = {
  key: 0,
  src: _imports_0
};
var _hoisted_91 = {
  key: 1,
  src: _imports_1
};
var _hoisted_92 = {
  key: 2,
  src: _imports_2
};
var _hoisted_93 = {
  key: 3,
  src: _imports_3
};
var _hoisted_94 = {
  key: 4,
  src: _imports_4
};
var _hoisted_95 = {
  class: "ml-1 flex-1"
};
var _hoisted_96 = {
  class: "num-part"
};
var _hoisted_97 = {
  class: "num"
};
var _hoisted_98 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "人", -1);
});
var _hoisted_99 = {
  class: "flex-1 h-100 position-relative"
};
var _hoisted_100 = {
  class: "attendance-echart-center"
};
var _hoisted_101 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "font-sm font-weight-bold mb-1"
  }, "总考勤人数", -1);
});
var _hoisted_102 = {
  class: "num-part"
};
var _hoisted_103 = {
  class: "num"
};
var _hoisted_104 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "人", -1);
});
var _hoisted_105 = {
  key: 8,
  class: "budget"
};
var _hoisted_106 = /*#__PURE__*/_createStaticVNode("<div class=\"flex justify-between align-center mb-1\" data-v-0e15c8af><span class=\"budget-title\" data-v-0e15c8af>总预算收入</span><div class=\"num-part\" data-v-0e15c8af><span class=\"num\" data-v-0e15c8af>0</span><span class=\"text\" data-v-0e15c8af>元</span></div></div><div class=\"flex justify-between align-center mb-1\" data-v-0e15c8af><span class=\"budget-title\" data-v-0e15c8af>总实际收入</span><div class=\"flex align-center\" data-v-0e15c8af><img src=\"" + _imports_5 + "\" data-v-0e15c8af><div class=\"num-part\" data-v-0e15c8af><span class=\"num\" data-v-0e15c8af>0</span><span class=\"text\" data-v-0e15c8af>元</span></div></div></div>", 2);
var _hoisted_108 = {
  class: "flex justify-between align-center mb-1"
};
var _hoisted_109 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "budget-title"
  }, "执行率", -1);
});
var _hoisted_110 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "num-part ml-auto mr-1"
  }, [/*#__PURE__*/_createElementVNode("span", {
    class: "num"
  }, "0"), /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "%")], -1);
});
var _hoisted_111 = {
  class: "progress"
};
var _hoisted_112 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, null, -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_date_select = _resolveComponent("c-date-select");
  var _component_c_title = _resolveComponent("c-title");
  var _component_van_grid_item = _resolveComponent("van-grid-item");
  var _component_van_grid = _resolveComponent("van-grid");
  var _component_van_icon = _resolveComponent("van-icon");
  var _component_pie_echart = _resolveComponent("pie-echart");
  var _component_van_progress = _resolveComponent("van-progress");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_c_date_select, {
    backgroundColor: "#F5F7FF",
    textColor: "#333",
    arrowColor: "#999999",
    class: "mb-2",
    onConfirmDate: _ctx.confrimDate
  }, null, 8, ["onConfirmDate"]), _createVNode(_component_c_title, {
    title: "产线状态",
    showIcon: false
  }), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lineStatusList, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["item mb-2 position-relative", item.status === '0' ? 'bg-stop' : 'bg-run']),
      key: item.line_name,
      onClick: _cache[0] || (_cache[0] = function ($event) {
        return _ctx.jumpPage('ProReportAggregate', _ctx.params);
      })
    }, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.emptyStringFormat(item.line_name)), 1), _hoisted_5, _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.emptyStringFormat(item.openCloseTime)), 1), _createElementVNode("div", {
      class: _normalizeClass(["label-box", item.status === '0' ? 'bg-stop' : 'bg-run'])
    }, [_hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString(item.status === '0' ? '停机' : '运行'), 1)], 2)], 2);
  }), 128))]), _createVNode(_component_c_title, {
    title: "外部采购",
    showIcon: false
  }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.purchaseData, function (item, index) {
    return _openBlock(), _createElementBlock(_Fragment, null, [!_ctx.facIds.includes(_ctx.factoryID) || !['砂浆', '商砼'].includes(item.title) ? (_openBlock(), _createElementBlock("div", {
      class: "sale box1 mb-2 purchase",
      key: index,
      onClick: function onClick($event) {
        return _ctx.jumpPage(item.routeName, _ctx.params);
      }
    }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.emptyStringFormat(item.title)), 1), _createElementVNode("div", _hoisted_12, "数据：" + _toDisplayString(_ctx.curDate), 1)]), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, function (sItem, sKey) {
      return _openBlock(), _createElementBlock("div", {
        class: "flex-1 flex justify-center align-center",
        key: sKey
      }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.emptyStringFormat(parseInt(sItem.value))), 1), String(sItem.value).indexOf('.') !== -1 ? (_openBlock(), _createElementBlock("span", _hoisted_17, "." + _toDisplayString(String(sItem.value).slice(String(sItem.value).indexOf('.') + 1)), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.emptyStringFormat(sItem.desc)), 1)])]);
    }), 128))])], 8, _hoisted_9)) : _createCommentVNode("", true)], 64);
  }), 256)), _createVNode(_component_c_title, {
    title: "产量",
    showIcon: false
  }), _createElementVNode("div", _hoisted_19, [_createVNode(_component_van_grid, {
    class: "grid",
    gutter: 10,
    "column-num": 3
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.proSumary, function (item) {
        return _openBlock(), _createElementBlock(_Fragment, null, [!_ctx.facIds.includes(_ctx.factoryID) || !['砂浆', '商砼'].includes(item.desc) ? (_openBlock(), _createBlock(_component_van_grid_item, {
          key: item.line_name,
          onClick: function onClick($event) {
            return _ctx.jumpPage(item.routeName, _ctx.params);
          }
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1), _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.curDate1), 1)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.emptyStringFormat(parseInt(item.value))), 1), String(item.value).indexOf('.') !== -1 ? (_openBlock(), _createElementBlock("span", _hoisted_26, "." + _toDisplayString(String(item.value).slice(String(item.value).indexOf('.') + 1)), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.emptyStringFormat(item.desc) === '商砼' ? '方' : '吨'), 1)])])];
          }),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)], 64);
      }), 256))];
    }),
    _: 1
  })]), !_ctx.facIds.includes(_ctx.factoryID) ? (_openBlock(), _createBlock(_component_c_title, {
    key: 0,
    title: "耗用",
    showIcon: false
  })) : _createCommentVNode("", true), !_ctx.facIds.includes(_ctx.factoryID) ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.emptyStringFormat('商砼耗用')), 1), _createElementVNode("div", _hoisted_30, [_createElementVNode("table", _hoisted_31, [_hoisted_32, _ctx.stReceivingData.list.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.stReceivingData.list, function (item, index) {
    return _openBlock(), _createElementBlock("tr", {
      key: index
    }, [_createElementVNode("td", null, _toDisplayString(item.stone_name), 1), _createElementVNode("td", null, [_createElementVNode("span", null, _toDisplayString(_ctx.emptyStringFormat(parseInt(item.net_weight + ''))), 1), String(item.net_weight).indexOf('.') !== -1 ? (_openBlock(), _createElementBlock("span", _hoisted_33, "." + _toDisplayString(String(item.net_weight).slice(String(item.net_weight).indexOf('.') + 1)), 1)) : _createCommentVNode("", true)]), _createElementVNode("td", null, _toDisplayString(item.sale_price), 1), _createElementVNode("td", null, [_createElementVNode("span", null, _toDisplayString(_ctx.emptyStringFormat(parseInt(item.tot_money))), 1), String(item.tot_money).indexOf('.') !== -1 ? (_openBlock(), _createElementBlock("span", _hoisted_34, "." + _toDisplayString(String(item.tot_money).slice(String(item.tot_money).indexOf('.') + 1)), 1)) : _createCommentVNode("", true)])]);
  }), 128)) : (_openBlock(), _createElementBlock("tr", _hoisted_35, _hoisted_37))])])])) : _createCommentVNode("", true), !_ctx.facIds.includes(_ctx.factoryID) ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.emptyStringFormat('砂浆耗用')), 1), _createElementVNode("div", _hoisted_40, [_createElementVNode("table", _hoisted_41, [_hoisted_42, _ctx.sjReceivingData.list.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.sjReceivingData.list, function (item, index) {
    return _openBlock(), _createElementBlock("tr", {
      key: index
    }, [_createElementVNode("td", null, _toDisplayString(item.stone_name), 1), _createElementVNode("td", null, [_createElementVNode("span", null, _toDisplayString(_ctx.emptyStringFormat(parseInt(String(item.net_weight)))), 1), String(item.net_weight).indexOf('.') !== -1 ? (_openBlock(), _createElementBlock("span", _hoisted_43, "." + _toDisplayString(String(item.net_weight).slice(String(item.net_weight).indexOf('.') + 1)), 1)) : _createCommentVNode("", true)]), _createElementVNode("td", null, _toDisplayString(item.sale_price), 1), _createElementVNode("td", null, [_createElementVNode("span", null, _toDisplayString(_ctx.emptyStringFormat(parseInt(String(item.tot_money)))), 1), String(item.tot_money).indexOf('.') !== -1 ? (_openBlock(), _createElementBlock("span", _hoisted_44, "." + _toDisplayString(String(item.tot_money).slice(String(item.tot_money).indexOf('.') + 1)), 1)) : _createCommentVNode("", true)])]);
  }), 128)) : (_openBlock(), _createElementBlock("tr", _hoisted_45, _hoisted_47))])])])) : _createCommentVNode("", true), _createVNode(_component_c_title, {
    title: "销量",
    showIcon: false
  }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saleData, function (item) {
    return _openBlock(), _createElementBlock(_Fragment, null, [!_ctx.facIds.includes(_ctx.factoryID) || !['砂浆', '商砼'].includes(item.desc) ? (_openBlock(), _createElementBlock("div", {
      key: item.desc,
      class: "sale box1 mb-2",
      onClick: function onClick($event) {
        return _ctx.jumpPage(item.routeName, _ctx.params);
      }
    }, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1), _createElementVNode("div", _hoisted_51, "数据：" + _toDisplayString(_ctx.curDate), 1)]), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.emptyStringFormat(parseInt(item.amount))), 1), String(item.amount).indexOf('.') !== -1 ? (_openBlock(), _createElementBlock("span", _hoisted_57, "." + _toDisplayString(String(item.amount).slice(String(item.amount).indexOf('.') + 1)), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_58, " 总销量/" + _toDisplayString(item.desc === '商砼' ? '方' : '吨'), 1)])]), _hoisted_59, _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.emptyStringFormat(parseInt(item.money))), 1), String(item.money).indexOf('.') !== -1 ? (_openBlock(), _createElementBlock("span", _hoisted_64, "." + _toDisplayString(String(item.money).slice(String(item.money).indexOf('.') + 1)), 1)) : _createCommentVNode("", true)]), _hoisted_65])]), _hoisted_66, _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.emptyStringFormat(parseInt(item.totalSingular))), 1), String(item.totalSingular).indexOf('.') !== -1 ? (_openBlock(), _createElementBlock("span", _hoisted_71, "." + _toDisplayString(String(item.totalSingular).slice(String(item.totalSingular).indexOf('.') + 1)), 1)) : _createCommentVNode("", true)]), _hoisted_72])]), _hoisted_73, _createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_createElementVNode("div", _hoisted_76, [_createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.emptyStringFormat(parseInt(item.totalAveragePrice))), 1), String(item.totalAveragePrice).indexOf('.') !== -1 ? (_openBlock(), _createElementBlock("span", _hoisted_78, "." + _toDisplayString(String(item.totalAveragePrice).slice(String(item.totalAveragePrice).indexOf('.') + 1)), 1)) : _createCommentVNode("", true)]), _hoisted_79])])])], 8, _hoisted_48)) : _createCommentVNode("", true)], 64);
  }), 256)), !_ctx.facIds.includes(_ctx.factoryID) ? (_openBlock(), _createBlock(_component_c_title, {
    key: 3,
    title: "收款",
    showIcon: false
  }, {
    info: _withCtx(function () {
      return [_ctx.moneyEditPermission ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_van_icon, {
        name: "edit",
        color: "#4372f6",
        size: "5vw",
        class: "ml-auto",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.jumpPage('collectionCorrection');
        })
      }), _hoisted_80], 64)) : _createCommentVNode("", true)];
    }),
    _: 1
  })) : _createCommentVNode("", true), !_ctx.facIds.includes(_ctx.factoryID) ? (_openBlock(), _createElementBlock("div", _hoisted_81, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collectionList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: "flex-1 item flex justify-center",
      key: index
    }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_82, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_83, [_createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.emptyStringFormat(parseInt(item.value))), 1), String(item.value).indexOf('.') !== -1 ? (_openBlock(), _createElementBlock("span", _hoisted_85, "." + _toDisplayString(String(item.value).slice(String(item.value).indexOf('.') + 1)), 1)) : _createCommentVNode("", true), _hoisted_86])])]);
  }), 128))])) : _createCommentVNode("", true), !_ctx.facIds.includes(_ctx.factoryID) ? (_openBlock(), _createBlock(_component_c_title, {
    key: 5,
    title: "考勤",
    showIcon: false
  }, {
    info: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_87, "数据：" + _toDisplayString(_ctx.curDate), 1)];
    }),
    _: 1
  })) : _createCommentVNode("", true), !_ctx.facIds.includes(_ctx.factoryID) ? (_openBlock(), _createElementBlock("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendanceData, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: "item flex align-center",
      key: item.desc
    }, [index === 0 ? (_openBlock(), _createElementBlock("img", _hoisted_90)) : index === 1 ? (_openBlock(), _createElementBlock("img", _hoisted_91)) : index === 2 ? (_openBlock(), _createElementBlock("img", _hoisted_92)) : index === 3 ? (_openBlock(), _createElementBlock("img", _hoisted_93)) : (_openBlock(), _createElementBlock("img", _hoisted_94)), _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1), _createElementVNode("div", _hoisted_96, [_createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.emptyStringFormat(item.num)), 1), _hoisted_98])]);
  }), 128))]), _createElementVNode("div", _hoisted_99, [_createVNode(_component_pie_echart, _normalizeProps(_guardReactiveProps(_ctx.attendaceEchartData)), null, 16), _createElementVNode("div", _hoisted_100, [_hoisted_101, _createElementVNode("div", _hoisted_102, [_createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.require_count), 1), _hoisted_104])])])])) : _createCommentVNode("", true), !_ctx.facIds.includes(_ctx.factoryID) ? (_openBlock(), _createBlock(_component_c_title, {
    key: 7,
    title: "预算",
    showIcon: false
  })) : _createCommentVNode("", true), !_ctx.facIds.includes(_ctx.factoryID) ? (_openBlock(), _createElementBlock("div", _hoisted_105, [_hoisted_106, _createElementVNode("div", _hoisted_108, [_hoisted_109, _hoisted_110, _createElementVNode("div", _hoisted_111, [_createVNode(_component_van_progress, {
    "pivot-text": "",
    percentage: 0,
    "stroke-width": "7",
    color: "linear-gradient(to right, #0047FC, #1593FC)"
  })])])])) : _createCommentVNode("", true), _hoisted_112])]);
}